"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CmsServiceImpl {
    cmsRepository;
    constructor(cmsRepository) {
        this.cmsRepository = cmsRepository;
    }
    async listFundContent() {
        const response = await this.cmsRepository.listFundContent();
        return response.data.map((item) => ({
            id: item.fundid,
            comment: item.comentario,
            image: item.diversificacionimage,
            heritage: item.patrimonio,
            description: item.description,
            percentageAnnualReturn: item.percentageannualreturn || '',
            percentageReturnText: item.percentagereturntext || '',
            percentageReturnSubText: item.percentagereturnsubtext || '',
            recommendedYears: item.recommendedyears,
            name: item.name,
            risk: item.risk,
            localCustody: item.localcustody,
            foreignCustodian: item.foreigncustodian,
            referenceIndex: JSON.parse(item.referenceindex),
            graphMinQuotaValue: item.graphminquotavalue,
            graphMaxQuotaValue: item.graphmaxquotavalue,
            currency: item.currency,
            factsheet: item.factsheet,
        }));
    }
}
exports.default = CmsServiceImpl;
//# sourceMappingURL=CmsServiceImpl.js.map